<template>
  <div class="page dark intro">


    <div id="about" class="inner">
      <h1>The Studio</h1>
        <p>Copse Corner offers professional services covering all aspects of music production; from Pre-Production to Mastering. We produce industry standard, professional recordings for solo artists and bands in all genres. The studio is also equipped for music and sound to motion picture and voice dubbing.</p>
        
        <p>Whilst always working professionally and to the highest quality, we believe that music and recording should be an enjoyable and rewarding experience. Therefore we always try to keep the environment in the studio as relaxed and informal as possible. Our competitively priced lock-out sessions allow for you to work at your own pace, without the pressure and worry of time and costs.</p>
        <p>When it comes to recording, there are no rules and practices that are set in stone. Every musician likes to do things differently and has different requirements, therefore we will always work with you to achieve the best results, and see your project reach its full potential. No idea or suggestion is ever too stupid!</p>
    </div>
  </div>
</template>

<script>


export default {
  name: 'intro'
}
</script>

<style scoped lang="scss">

.intro{

  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 75vh;
  .inner{
    max-width: 1200px;
    
    padding:0 5%;

  }
}



</style>
